"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwtIsValid = exports.jwtExpired = void 0;
const luxon_1 = require("luxon");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const jwtExpired = (token) => luxon_1.DateTime.utc().toSeconds() >= (0, jwt_decode_1.default)(token).exp;
exports.jwtExpired = jwtExpired;
const jwtIsValid = (token) => !!token && !(0, exports.jwtExpired)(token);
exports.jwtIsValid = jwtIsValid;
